<div *ngIf="!loading">
  <input id="wellsearch" [(ngModel)]="search" class="form-control filter-input" style="margin-bottom:20px;" placeholder="Search by Well Name, Field Name, Battery Name, API or Serial Number" />
  <form [formGroup]="wellACLFrm">
    <div class="form-row">
      <div class="form-group col-md-6">
        <select class="form-control" formControlName="field" (change)="fieldChanged()">
          <option [value]="null" selected [selected]="null == this.wellACLFrm.controls['field'].value">Select a field</option>
          <option *ngFor="let field of fields" [value]="field.fieldID">
            {{field.fieldName}}
          </option>
        </select> 

      </div>

      <div class="form-group col-md-6">
        <select class="form-control" formControlName="battery" (change)="batteryChanged()">
          <option [value]="null" selected [selected]="null == this.wellACLFrm.controls['battery'].value">Select a battery</option>
          <option *ngFor="let bat of batteries " [value]="bat.batteryID">
            {{bat.batteryName}}
          </option>
        </select>

      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-md-6">
        <div><button class="btn btn-outline-success" *ngIf="(this.mode != 0 && this.mode.toString() != 'editMode')" [disabled]="wellsAva.length == 0" (click)="addAll()">Add All</button></div>
        <label for="avaTable" class="form-control-label">Available Wells {{wellsAva.length}}</label>
        <div style="max-height:500px;overflow-y:scroll;" *ngIf="wellsAva.length > 0">
          <table class=" table table-hover" id="avaTable" name="avaTable">
            <tr>
              <th>Well Name <i class="fas fa-sort" (click)="orderList('wellName','wa')"></i></th>
              <th>Field <i class="fas fa-sort" (click)="orderList('fieldName','wa')"></i></th>
              <th>Battery <i class="fas fa-sort" (click)="orderList('batteryName','wa')"></i></th>
              <th></th>
            </tr>
            <tr *ngFor="let wa of wellsAva  | wellsACLFilter: search: dummbyValue1 ;let i = index">
              <td>{{wa.wellName}} </td>
              <td>{{wa.fieldName}}</td>
              <td>{{wa.batteryName}}</td>
              <td style="width:60px;"><button type="button" class="btn btn-outline-success" (click)="changeWellAssoc(wa,true , i)"><i class="{{wa.lockIcon}}"></i></button></td>
            </tr>
          </table>
        </div>
        <div *ngIf="wellsAva.length == 0" class="alert alert-info" role="alert">
          No Wells available.
        </div>
      </div>

      <div class="form-group col-md-6">
        <div><button class="btn btn-outline-danger" *ngIf="(this.mode != 0 && this.mode.toString() != 'editMode')" [disabled]="wellsOwned.length == 0" (click)="removeAll()">Remove All</button></div>
        <label class="form-control-label" for="ownedTable">Visible Wells  {{wellsOwned.length}}</label>
        <div style="max-height:500px;overflow-y:scroll;" *ngIf="wellsOwned.length > 0">
          <table class=" table table-hover" id="ownedTable" name="ownedTable">
            <tr>
              <th>Well Name <i class="fas fa-sort" (click)="orderList('wellName','wo')"></i></th>
              <th>Field <i class="fas fa-sort" (click)="orderList('fieldName','wo')"></i></th>
              <th>Battery <i class="fas fa-sort" (click)="orderList('batteryName','wo')"></i></th>
              <th></th>
            </tr>
            <tr *ngFor="let wo of wellsOwned | wellsACLFilter: search: dummbyValue2;let i = index">
              <td>{{wo.wellName}} </td>
              <td>{{wo.fieldName}}</td>
              <td>{{wo.batteryName}}</td>
              <td style="width:60px;"><button type="button" class="btn btn-outline-danger" (click)="changeWellAssoc(wo,false , i)"><i class='{{wo.lockIcon}}'></i></button></td>
            </tr>
          </table>
        </div>
        <div *ngIf="wellsOwned.length == 0" class="alert alert-info" role="alert">
          No Wells associated.
        </div>
      </div>
    </div>

  </form>

  
</div>
 
<div style="width:100%">
  <div *ngIf="loading"  class="spinner-border" style="width: 3rem; height: 3rem; display:flex;margin-left:auto;margin-right:auto;" role="status"></div>
</div>
